import { ELoadingStatus } from 'API/types';
export const getInitialState = () => ({
    loadingStatus: ELoadingStatus.Init,
    listFetchingError: false,
    errorCollection: {},
    datasetsCollection: {},
    dataCollection: {},
});
